<template>
  <div class="services-component" ref="newsList">
    <div class="area">
      <div class="row services-container" v-animated-show="utils.handleScroll">
        <h1 v-html="title" class="float-title col-4 col-md-12"></h1>
        <section
          class="list-section-banner col-4 col-md-12"
          v-for="(l, i) in list"
          ref="news"
          :key="i"
        >
          <div class="content">
            <Description
              class="icon-top mini"
              ref="bannerDescription"
              :isMoreTop="true"
              :title="l.title"
              :desc="l.desc"
              :button="l.button"
              :href="l.href"
              :icon="l.icon"
              v-if="l.title"
            />
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../utils";
export default {
  name: "Services",
  props: {
    title: String,
    button: String,
    list: Array,
  },
  data() {
    return {
      utils: utils,
      greyscale: [],
      currentY: 0,
    };
  },
  methods: {
    onChange(currentY) {
      this.currentY = currentY;
    },
    onScroll() {
      this.$refs.news.forEach((element, index) => {
        let top = element.getBoundingClientRect().top;
        this.greyscale[index] = top > this.currentY && index !== 0;
      });
      this.greyscale = [...this.greyscale];
    },
  },
  beforeDestroy() {
    if (document.getElementById("page-container")) {
      document
        .getElementById("page-container")
        .removeEventListener("scroll", this.onScroll);
    }
  },
  mounted() {
    document
      .getElementById("page-container")
      .addEventListener("scroll", this.onScroll);
    var i = 0;
    this.list.forEach(element => {
      this.greyscale.push(i != 0);
      switch (element.tag) {
        case "новость":
          element.tagColor = "color-red";
          break;
        case "анонс":
          element.tagColor = "color-blue";
          break;
        case "предложение":
          element.tagColor = "color-cyan";
          break;
      }
      element.column = i % 2 === 0;
      if (element.img.src !== "") {
        i += 2;
      } else {
        i += 1;
      }
    });
  },
  components: {},
};
</script>

<style lang="scss">
.services-component {
  @extend %page-block;
  .float-title {
    @media all and (max-width: $md) {
      margin-bottom: 70px;
    }
    @extend %float-title;
    margin-right: 10%;
  }
  .services-container {
    @media all and (max-width: $md) {
      grid-row-gap: 36px;
    }
    grid-row-gap: 55px;
  }
  .list-section-banner {
    transition: color 0.5s;
    margin-right: 36px;
    .more {
      transition: color 0.5s;
    }
    .description {
      @media all and (max-width: $md) {
        grid-row-gap: 19px;
      }
      grid-gap: 27px;
      .description-content {
        grid-gap: 17px;
      }
      &.mini {
        .desc {
          line-height: 1.5em;
        }
      }
    }
    .description.icon-top {
      .icon {
        @media all and (max-width: $md) {
          grid-row-gap: 36px;
        }
        width: 93px;
        height: 93px;
        border-radius: 50%;
        background: $bg-grey-dark;
      }
    }
    .default {
      .title {
        @media all and (max-width: $md) {
          font-size: 18px;
        }
      }
      .desc {
        @media all and (max-width: $md) {
          font-size: 12px;
        }
      }
      .more {
        @media all and (max-width: $md) {
          font-size: 12px;
          font-weight: bold;
        }
        @extend %text-h4;
        font-weight: bold;
        font-size: 16px;
      }
    }
    .mini {
      .more {
        @extend %text-h5;
        font-weight: bold;
        font-size: 12px;
      }
    }
  }
  .button-load-more {
    @media all and (max-width: $md) {
      grid-column: 1 / span 12;
    }
    grid-column: 6 / span 7;
    justify-self: center;
    justify-items: center;
    display: grid;
    grid-gap: 15px;
    @extend %text-h5;
    .button {
      width: 42px;
      &::before {
        transform: rotate(-90deg);
      }
    }
    span {
    }
    transition: color 0.5s;
    color: $text-main-quart;

    &:hover {
      border-color: transparent;
      color: $text-main;
      .button {
        background: $color-accent;
        &::before {
          color: $text-inverse-main;
        }
      }
    }
  }
  .scroll-marker {
    @media all and (max-width: $md) {
      display: none;
    }
    top: 300px;
    position: absolute;
    bottom: -54px;
    grid-column: 6;
    margin-left: -27px;
  }
}
</style>
